// Application Constants
export const APP_NAME = 'LokVir Impex';
export const APP_TAGLINE = 'BUILDING TRADITION, EXPORTING EXCELLENCE';
export const APP_DESCRIPTION = 'Discover handcrafted bamboo products for sustainable living. Premium quality meets sustainability.';

// Contact Information
export const CONTACT_EMAIL = 'lokvirimpex@gmail.com';
export const CONTACT_PHONE = '+91 84317 58550';
export const CONTACT_ADDRESS = 'Mumbai, Maharashtra, India';

// Color Palette
export const COLORS = {
  primary: {
    light: '#9be830',
    DEFAULT: '#79974e',
    dark: '#6d8544',
  },
  background: {
    light: '#fafcf8',
    medium: '#f5f9f0',
    dark: '#eef3e7',
  },
  text: {
    primary: '#151b0e',
    secondary: '#79974e',
  },
  accent: {
    light: '#8bd020',
    DEFAULT: '#9be830',
  },
};

// Routes
export const ROUTES = {
  HOME: '/',
  PRODUCTS: '/products',
  CONTACT: '/contact',
  SHOP: '/shop',
  ACCOUNT: '/account',
};

// Category Mappings
export const CATEGORY_MAPPINGS = {
  'Home Decore & Gifts': 'homeDecoreGifts',
  'Kitchenware': 'kitchenware',
  'Furniture': 'furniture',
  'Lamps': 'lamps',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_EMAIL: 'userEmail',
};

// Animation Delays
export const ANIMATION_DELAYS = {
  STAGGER: 100, // milliseconds
};

